// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primary":"#56CCF2","secondary":"_8sA_4btqq5DlFPW0rXoMY","textDefault":"#808080","inputWrapper":"_3I5gr3nBY5oXcrR9NggzCr","textarea":"_1iwG8nCCaTR6tmOaAka4IR","border":"_1UJAqxrWZnWoy44N3I5DLl","invalid":"_1A-mq8aJUPMwCu3Nf5-6xt","centered":"L8x-iKTApALyZjeNoAxRg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TextArea/TextArea.mod.css
// module id = 1128
// module chunks = 0